export default {
  // 设置下划线
  setEnableUnderline(state, { value, node }) {
    const targetNode = node || state.activeNode
    targetNode.enableUnderline = value
    if (value) {
      targetNode.underlineWidth = 5
      targetNode.underlineSpacing = 3
    }
  },

  // 设置删除线
  setEnableDeleteline(state, { value, node }) {
    const targetNode = node || state.activeNode
    targetNode.enableDeleteline = value
    if (value) {
      targetNode.deletelineWidth = 5
    }
  },

  // 设置字距
  setLetterSpacing(state, { value, node }) {
    const targetNode = node || state.activeNode
    targetNode.letterSpacing = value
  },

  setLineHeight(state, { value, node }) {
    const targetNode = node || state.activeNode
    targetNode.lineHeight = value
  }
}
